<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{ 'Accounting Department Data' | translate }}</h1>
      <p>{{wk_Title | translate }}</p>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{wk_Title | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 100px;">{{ 'Serial' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogSerial()"></span>
            <input type="text" name="expSerial" placeholder="" required="" style="width: 152px;" [(ngModel)]="hedserial" (change)="retriveStockHd()">
            <label style="width: 300px;"></label>
            <label style="width: 50px;">{{ 'Date' | translate }}</label>
            <input type="date" name="expdate"  required="" style="width: 200px;" [(ngModel)]="heddate">
          </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Program' | translate }}</label>
          <select id="kind" name="trkind" class="example-label"  style="width: 200px;background-color:  rgb(187, 203, 238);" [(ngModel)]= "hedprogramno" [value]="hedprogramno"  required>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
          </select>
          <label style="width: 300px;"></label>
          <label style="width: 50px;">{{ 'Store' | translate }}</label>
          <select id="trstore" name="trsstor" class="example-label" style="width: 400px;background-color:  rgb(187, 203, 238);" [(ngModel)]="hedstore"  >
            <option *ngFor="let cur of storesList" value="{{cur.strcode}}" >{{cur.strdesc1}}</option>
          </select>
        </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{wk_Customer_Supplier | translate }}</label>
          <!-- <select id="kind" name="trsalute" class="example-label"  style="width: 100px;background-color:  rgb(187, 203, 238);" [(ngModel)]= "hedtax1" [value]="hedtax1"  required>
              <option value="السيـــد">السيـــد</option>
              <option value="السيــدة">السيــدة</option>
              <option value="الأستـاذ">الأستـاذ</option>
              <option value="الأستاذه">الأستاذه</option>
              <option value="الدكتــور">الدكتــور</option>
              <option value="الدكتورة">الدكتورة</option>
              <option value="الأنـــسة">الأنـــسة</option>
              <option value="الحــــاج">الحــــاج</option>
              <option value="الحـاجـه">الحـاجـه</option>
              <option value="السفيــر">السفيــر</option>
          </select> -->
          <input type="text" name="pacode"  required="" style="width: 200px;" [(ngModel)]="hedsup_client" (change)="RetrivePatient()" >
          <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogPatient()"></span>
          <label id="w3l-appointment" class="appointment-form-field" style="width: 200px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{patientName}}</label>

          <label style="width: 50px;"></label>
          <label style="width: 50px;">{{ 'Room' | translate }}</label>
          <select class="example-label" id="rooms" name="rooms" required="" style="width: 400px;background-color:  rgb(187, 203, 238);" [(ngModel)]="hedroomnumber" [value]="hedroomnumber" >
            <option value="">None</option>
            <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
        </select>
        </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Notes' | translate }}</label>
          <input type="text" name="notes"  required="" style="width: 950px;" [(ngModel)]="heddescription">
        </div>
    </form>
  </div>
  </div>
</div>
<BR>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <table style="width: 1050px;">
            <thead>
                <tr>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;height: 10%;">{{ 'Line' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;">{{ 'Item Code' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:30%;height: 10%;">{{ 'Item Name' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;">{{ 'QTY' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;">{{ 'Price' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;">{{ 'Value' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 10%;">{{ 'Notes' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 10%;">{{ 'Select' | translate }}</th>
                </tr>
            </thead>
            <tbody>

              <tr *ngFor="let pro of stocktrndetList; let i = index" style="height: 50%;font-weight: bold;">
                <td data-column="Patient ID" style="height: 10%;">{{pro.detline}}</td>
                <td data-column="Patient Name"style="height: 100%;">{{pro.detitem}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detitemname}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detqty | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detprice | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detvalue | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detdescription}}</td>
                <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectLine(pro)">Select</button>
              </tr>
            </tbody>
          </table>
      </form>
    </div>
    </div>
  </div>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <table style="width: 1050px;">
            <thead>
                <tr>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:29%;height: 10%;font-size: 120%;font-weight: bold;">{{ 'Total' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;font-size: 120%;font-weight: bold;">{{Wk_total | number:'1.2-2'}}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 10%;"></th>
                </tr>
            </thead>
            <tbody>


            </tbody>
          </table>
      </form>
    </div>
    </div>
  </div>

      <div id="w3l-appointment"  class="wrapper d-grid doctor-appointment">
        <button type="button" class="theme-button btn" style="width: 14.5%;height: 50px;font-weight: bold;background-color: #2e57d4;color: ghostwhite;" name="new" (click)="New_Line()">{{ 'New Record' | translate }}</button>

      </div>
      <BR>
      <div id="w3l-appointment">
      <div class="wrapper d-grid doctor-appointment">
      <form action="#" method="post" >
        <div class="appointment-form-field">
          <label style="width: 500px;"></label>
          <label style="width: 180px;">{{ 'Discount Amount' | translate }}</label>
          <input type="number" name="heddisc1" placeholder="" required="" style="width: 120px;font-weight: bold;color: rgb(237, 16, 16);" [(ngModel)]="heddisc1" (change)="ClucDiscPer()">
        </div>
        <div class="appointment-form-field">
          <label style="width: 500px;"></label>
          <label style="width: 180px;font-weight: bold;">{{ 'Net Value' | translate }}</label>
          <label id="w3l-appointment" class="appointment-form-field" style="width: 120px;font-weight: bold;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{Wk_Net_Value |  number:'1.2-2'}}</label>
        </div>
      </form>
    </div>
  </div>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="submit" (click)="submitInvoice()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="MesgDelete()">{{ 'Delete' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
    <a href="AccTransactions">
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
    <BR>

</section>

